export const LOADER_INITIAL_STATE = {
    filter: {
        name: '',
        show: 'active',
    },
    createLoaderInitial: {
        name: '',
        active: true,
        feedLotId: '',
    },
    loader: true,
};
